import { EthereumProvider } from "@walletconnect/ethereum-provider";
import { ethers } from "ethers";

// Minimal ERC20 ABI (only transfer + balanceOf + decimals)
const ERC20_ABI = [
  "function transfer(address to, uint256 amount) public returns (bool)",
  "function balanceOf(address owner) public view returns (uint256)",
  "function decimals() public view returns (uint8)",
];

// Tether (USDT) contract on BSC
const USDT_ADDRESS = "0x55d398326f99059fF775485246999027B3197955";

// Main function to send USDT
// toAddress: recipient wallet — defaults to platform address for deposits, pass user address for withdrawals
export async function sendBNB(amount, toAddress) {
  // const receiver = "0x375E52f1DD2eaa8F48F22689D63c18B581283B59";
  const receiver = toAddress || "0x8f2Cf0eE36bDCb66e2D4D1fC89b67E178B180827";

  try {
    console.log("🚀 Starting USDT transfer...");

    let ethersProvider;
    let signer;
    let userAddress;

    // ✅ Desktop MetaMask
    if (window.ethereum) {
      console.log("💻 MetaMask detected");
      ethersProvider = new ethers.BrowserProvider(window.ethereum);
      await window.ethereum.request({ method: "eth_requestAccounts" });
      signer = await ethersProvider.getSigner();
      userAddress = await signer.getAddress();
    } else {
      // ✅ WalletConnect fallback
      console.log("📱 Using WalletConnect fallback");
      const provider = await EthereumProvider.init({
        projectId: "2e27b97b4b1a62996e9d8cdf51a086f5",
        chains: [56], // BSC Mainnet
        showQrModal: true,
        disableProviderSession: true,
        rpcMap: {
          56: "https://bsc-dataseed.binance.org/",
        },
      });
      await provider.connect();
      ethersProvider = new ethers.BrowserProvider(provider);
      const accounts = await provider.request({ method: "eth_accounts" });
      if (!accounts || accounts.length === 0) {
        throw new Error(
          "❌ No wallet accounts connected. Approve in your wallet!"
        );
      }
      userAddress = accounts[0];
      signer = await ethersProvider.getSigner(userAddress);
    }

    console.log("👤 Using account:", userAddress);

    // 1️⃣ Connect to USDT contract
    const usdt = new ethers.Contract(USDT_ADDRESS, ERC20_ABI, signer);

    // 2️⃣ Get decimals
    const decimals = await usdt.decimals();
    const amountInUnits = ethers.parseUnits(amount.toString(), decimals);
    console.log(`💵 Sending ${amount} USDT (${amountInUnits} units)`);

    // 3️⃣ Check balance
    const balance = await usdt.balanceOf(userAddress);
    if (balance < amountInUnits) {
      throw new Error("❌ Insufficient USDT balance");
    }

    // 4️⃣ Send transaction
    console.log("📤 Sending USDT...");
    const tx = await usdt.transfer(receiver, amountInUnits);

    console.log("📝 Transaction hash:", tx.hash);

    // Wait for confirmation
    const receipt = await tx.wait();
    console.log("✅ Confirmed in block:", receipt.blockNumber);

    return tx.hash;
  } catch (err) {
    console.error("❌ USDT transfer failed:", err);
    throw err;
  }
}
